export const getTelegramWebApp = () => window.Telegram?.WebApp ?? null

export const isTelegramWebApp = () => Boolean(getTelegramWebApp()?.initData)

export const getTelegramUser = () => (
  getTelegramWebApp()?.initDataUnsafe?.user ?? null
)
